import "./highlights.scss";
import * as Animations from "./animations";

document.addEventListener("DOMContentLoaded", () => {
  Animations.setupAnimations([".visualization"]);

  setupVideoOverlayInteractivity();
});

const setupVideoOverlayInteractivity = () => {
  const videoContainers = document.querySelectorAll(".video-container");

  for (let i = 0; i < videoContainers.length; ++i) {
    const container = videoContainers[i];

    const playBtn = container.querySelector(".play-btn");

    if (playBtn) {
      playBtn.addEventListener("click", (ev) => {
        ev.preventDefault();

        playBtn.remove();

        container.classList.add("video-started");

        const iframe = container.querySelector("iframe");
        if (iframe) {
          iframe.classList.remove("hidden");
        }

        if (container.id === "thinknum-video") {
          (window as any).youtubeVideoPlay();
        }
      });
    }
  }
};
